import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const payoutsModule = defineModule({
  name: "payouts",
  label: "Payouts",
  requires: ["core", "accounts", "configuration", "audit", "catalog"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "settings/commission",
        permission: "payouts.view_commissionrule",
        page: () => import("./admin/CommissionPage"),
      },
      {
        path: "payouts",
        permission: "payouts.view_payout",
        page: () => import("./admin/PayoutsPage"),
      },
    ],
    nav: [
      {
        id: "commission",
        group: "settings",
        label: "payouts:commission.nav",
        icon: "trending",
        to: "/settings/commission",
        permission: "payouts.view_commissionrule",
        order: 3,
      },
      {
        id: "payouts",
        group: "business",
        label: "payouts:nav.payouts",
        icon: "wallet",
        to: "/payouts",
        permission: "payouts.view_payout",
        order: 7,
      },
    ],
  },
  // the store's own earnings (team code `payouts.view`: owners), vendor step 14
  vendor: {
    routes: [
      { path: "earnings", permission: "payouts.view", page: () => import("./vendor/EarningsPage") },
    ],
    nav: [
      {
        id: "earnings",
        group: "sales",
        label: "payouts:nav.earnings",
        icon: "wallet",
        to: "/earnings",
        permission: "payouts.view",
        order: 30,
      },
    ],
  },
});
